export const CommonConfig = {
  opertion: [
    {id: 1, name: "Driver route change"},
    {id: 4, name: "Announcements"},
    {id: 5, name: "Vehicle temporary change"},
    {id: 6, name: "Vehicle change with whatsapp link"},
    {id: 9, name: "Vehicle Tracking disable"}
  ]
};
